// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"2176d5c1","223":"a585929f","306":"65514451","679":"62911cbe"}[chunkId] + ".chunk.js";
};